import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setIsAddPhotoWidgetOpen } from '@/store/slices/progressSlice';
import { path } from '@/routes/Routes.helpers';
import { useClothingByParentCategories } from '@/hooks/useClothingByParentCategories';
import IcoStars from '@/assets/svg/ico_stars.svg?react';
import Button from '@/components/controls/Button/Button.component';
import EmptyWardrobeInfoModal from '@/components/elems/EmptyWardrobeInfoModal/EmptyWardrobeInfoModal.component';
import DropDownMenu from '@/components/interactive/DropDownMenu/DropDownMenu.component';
import { TAB_BAR_WIDGET_MENU } from '@/components/widgets/TabBarWidget/TabBarWidgetMenu/TabBarWidgetMenu.config';
import styles from '@/components/widgets/TabBarWidget/TabBarWidgetMenu/TabBarWidgetMenu.module.scss';
import { TabBarWidgetMenuPropsIF } from '@/components/widgets/TabBarWidget/TabBarWidgetMenu/TabBarWidgetMenu.types';

const TabBarWidgetMenu: FC<TabBarWidgetMenuPropsIF> = ({ isNeedHighlight }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { categoriesData } = useClothingByParentCategories();

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isDropDownMenu, setIsDropDownMenu] = useState<boolean>(false);

    const clickHandler = (): void => {
        if (categoriesData) {
            navigate(path('outfitsCreate'));
            return;
        }

        setIsModalOpen(true);
    };

    const menuClickHandler = (
        action: (typeof TAB_BAR_WIDGET_MENU)[number]['action'],
    ): void => {
        setIsDropDownMenu(false);

        switch (action) {
            case 'myOutfits': {
                navigate(path('outfits'));
                return;
            }

            case 'createOutfit': {
                clickHandler();
                return;
            }
        }
    };

    return (
        <>
            <Button
                dataTest="button_open_menu"
                isCustom
                className={`flc ${styles.centerBtn} ${isNeedHighlight ? 'tourStepButton' : ''}`}
                clickHandler={() => setIsDropDownMenu(true)}
            >
                <IcoStars />
            </Button>

            {isModalOpen && (
                <EmptyWardrobeInfoModal
                    onClose={() => setIsModalOpen(false)}
                    openPhotoWidget={() =>
                        dispatch(setIsAddPhotoWidgetOpen(true))
                    }
                />
            )}

            {isDropDownMenu && (
                <DropDownMenu
                    onClose={() => setIsDropDownMenu(false)}
                    position="Bottom"
                >
                    {TAB_BAR_WIDGET_MENU.map((menu) => (
                        <Button
                            dataTest={`path_${menu.id}_button`}
                            isCustom
                            key={menu.id}
                            className={`flc ${styles.menuContainer}`}
                            clickHandler={() => menuClickHandler(menu.action)}
                        >
                            {menu.icon}
                            <div className={styles.menuTitle}>{menu.title}</div>
                        </Button>
                    ))}
                </DropDownMenu>
            )}
        </>
    );
};

export default TabBarWidgetMenu;
